// src/index.js
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// Check if this is a geo page (skip hydration for static geo pages)
const isGeoPage = window.location.pathname.includes('-in-');

// During prerendering, always hydrate to generate content
const isPrerendering = window.location.search.includes('prerender=true');

if (isGeoPage && !isPrerendering) {
  // Don't hydrate geo pages - they're static HTML with working <a> tags
  console.log('Skipping hydration for geo page:', window.location.pathname);
} else {
  // Hydrate for interactive pages or during prerendering
  hydrateRoot(rootElement, <App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Silence console logs in production (keep errors and warnings)
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  // Preserve error and warn; silence the rest
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

// Register a minimal service worker and auto-reload on update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (
              installing.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              // New content available; reload to get the latest UI/content
              window.location.reload();
            }
          });
        });
      })
      .catch(() => {});
  });
}
